"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const global_1 = require("../../commons/global");
const settings_component_1 = require("./settings.component");
const integrations_component_1 = require("./integrations.component");
const users_component_1 = require("./users.component");
const billing_component_1 = require("./billing.component");
const AppRouting = [
    { path: '', redirectTo: global_1.AppRoutes.ACCOUNT, pathMatch: 'full' },
    { path: global_1.AppRoutes.ACCOUNT, component: settings_component_1.SettingsComponent, pathMatch: 'full' },
    { path: 'plan', component: billing_component_1.BillingComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.APIS, component: integrations_component_1.IntegrationsComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.USERS, component: users_component_1.UsersComponent, pathMatch: 'full' }
];
class SettingsModule {
}
exports.SettingsModule = SettingsModule;
